import Vue from 'vue'
import store from "../store"
import u from "@/mixins/utils";
import { auth, subscriber } from '@/services/';
import { _ } from 'core-js';
import { data } from 'jquery';
const utils = u.methods;

export async function get_infos() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1000,
        data: {
            voyager: "calavi",
            bus: "reg_get_user_info"
        }
    };
    // if (localStorage.getItem('me_info_') == null) {
        var response = await utils.utils_async_ajax(config);
        if (_.isUndefined(response.error)) {
            localStorage.setItem('me_info_', JSON.stringify(response))
            Vue.set(store.state.core, "subscriber", response);
        }
        return response;
    // } else {
    //     return;
    // }

}


export async function get_main_balance() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1000,
        data: {
            voyager: "ouidah",
            bus: "air_gbad"
        }
    };
    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error)) {
        var a1 = response.balance?.split("Solde:") ?? "";
        a1 = a1[1].split("FCFA.");
        a1 = { balance: a1[0].trim(), description: a1[1].trim() };
        localStorage.setItem('b_l', a1.balance)
        Vue.set(store.state.core, "balance", a1);
        return a1;
    }
    return response;
}


export async function get_subscriptions() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1000,
        data: {
            voyager: "cotonou",
            bus: "cis_get_subscriptions"
        }
    };
    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error)) {
        Vue.set(store.state.core, "subscriptions", response);
    }
    return response;
}


export async function active_bundle(code) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "cotonou",
            bus: "cis_activate",
            passager: {
                code: code
            }
        }
    };
    return await utils.utils_async_ajax(config);
}


export async function deactive_bundle(code) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "cotonou",
            bus: "cis_deactivate",
            passager: {
                code: code
            }
        }
    };
    return await utils.utils_async_ajax(config);
}


export async function get_bundle_list() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "cotonou",
            bus: "cis_get_bundles",
            passager: {

            }
        }
    };
    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error)) {
        let bundle_groups = response;
        for(const key in bundle_groups.labels) {
            let grp = bundle_groups.labels[key];
            if(!_.isEmpty(bundle_groups[grp.id])) {
                let blds = bundle_groups[grp.id].filter(function(bld) {
                    return !_.isUndefined(bld.price) && parseInt(bld.price) > 0 && parseInt(bld.price) < 1000000;
                });

                if(blds.length == 0) {
                    bundle_groups.labels.splice(key, 1);
                    delete bundle_groups[grp.id];
                }
            }
        }
        
        Vue.set(store.state.core, "bundles", bundle_groups);
        // Vue.set(store.state.core, "bundles", response);
    }
    return response;
}


export async function get_bill_details(current_filter) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1000,
        data: {
            voyager: "calavi",
            bus: "reg_consommation",
            passager: { start: current_filter.start, end: current_filter.end }
        }
    };

    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error) && _.isUndefined(response.internal_error)) {
        Vue.set(store.state.core, "bill_details", response)
        Vue.set(store.state.core, "consommations", response);
        Vue.set(store.state.core, "download_produits", response.lines)
        var format = response.lines.map((element) => {
            return {
                ...element,
                duration: _.isNil(element.duration)
                    ? "-"
                    : element.duration,
                matched_date: utils.moment(element.record_time).format("ll"),
            };
        });
        const groupByDate = _.chain(format)
            .groupBy("matched_date")
            .map((value, key) => ({ matched_date: key, datas: value }))
            .value();
        Vue.set(store.state.core, "consommations", response)
        store.state.core.consommations.lines = groupByDate;
        Vue.set(store.state.core, "current_filter", current_filter)
    }
    return response;
}


export async function get_bill_internet_details(current_filter) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1000,
        data: {
            voyager: "malanville",
            bus: "bill_get_consuption",
            passager: { start: current_filter.start, end: current_filter.end }
        }
    };
    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error) && _.isUndefined(response.internal_error)) {
        if (current_filter.label === 'week') {
            Vue.set(store.state.core, "bill_internet", response.reponse);
        }
        Vue.set(store.state.core, "consommations_internet", response.reponse);
        Vue.set(store.state.core, "current_filter", current_filter)
    }
    return response;
}


export async function get_puk_and_puk() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "kandi",
            bus: "puk_details",
            passager: {

            }
        }
    };
    var response = await utils.utils_async_ajax(config);
    if (_.isUndefined(response.error)) {
        Vue.set(store.state.core, "puk", response);
    }
    return response;
}

export async function gmcvs(type) {

    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "agonli",
            bus: type,
            passager: {}
        }
    };
    return await utils.utils_async_ajax(config);
}

export async function globalServiceRequest(voyager, passager, bus) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: voyager,
            passager: passager,
            bus: bus
        }
    };
    return await utils.utils_async_ajax(config);
}

export async function functionsimSwap(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: 1,
        data: {
            voyager: "pahou",
            bus: 'wp_sim_swap',
            passager: data
        }
    };
    return await utils.utils_async_ajax(config);
}

export async function downloader(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "public/consumptions",
        type: "POST",
        show_error: true,
        data: data,
        retry: false
    };
    return await utils.utils_async_ajax(config);
}


export async function activate_bundle(data) {
    try {
        var config = {
            url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
            type: "POST",
            show_error: true,
            retry: false,
            data: {
                voyager: "cotonou",
                bus: "cis_activate",
                passager: data
            }
        };
        return await utils.utils_async_ajax(config);
    } catch (error) {
        return false;
    }
}

export async function checkFirstLogin() {
    subscriber.get_infos();
    // if (store.state.core.subscriber.infos.msisdn) {
        var config = {
            url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
            type: "POST",
            show_error: true,
            retry: 1000,
            data: {
                voyager: "copargo",
                bus: "users_first_time_connexion_infos",
                // passager: {
                //     msisdn: store.state.core.subscriber.infos.msisdn
                // }
            }
        };

        try {
            const response = await utils.utils_async_ajax(config);
            return response
        } catch (error) {
            console.log('error')
        }
    // }

}


export async function notifications_subscription(type, status) {
    let passager = {
    }
    if (type == 'produits') {
        passager = {
            msisdn: store.state.core.subscriber.infos.msisdn,
            subscribe_products: status
        }
    } else if (type == 'internet') {
        passager = {
            msisdn: store.state.core.subscriber.infos.msisdn,
            subscribe_internet: status
        }
    }
    try {
        var config = {
            url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
            type: "POST",
            show_error: true,
            retry: false,
            data: {
                voyager: "copargo",
                bus: "users_subscribe_consumptions_notif",
                passager: passager
            }
        };
        return await utils.utils_async_ajax(config);
    } catch (error) {
        console.log('error')
    }
}

export async function finishTour() {
    try {
        var config = {
            url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
            type: "POST",
            show_error: true,
            retry: false,
            data: {
                voyager: "copargo",
                bus: "users_guided_tour_completed",
                passager: {
                    msisdn: store.state.core.subscriber.infos.msisdn,
                }
            }
        };
        const response = await utils.utils_async_ajax(config);
        if (response.success) {
            Vue.set(store.state.core.first_login_configs, "already_guided", true);
        }
        return response
    } catch (error) {
        console.log('error')
    }
}


// MTN BUSINESS SERVICES
export async function business_account_number() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_get_account_number",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function business_last_month_bill() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_get_last_month_bill",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}
export async function get_account_outstanding() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_account_outstanding",
            passager: {
                entity_id: store.state.core.business_account.account_number,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function get_last_bills() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_last_bills",
            passager: {
                entity_id: store.state.core.business_account.account_number,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}


export async function get_mini_statement() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_mini_statement",
            passager: {
                entity_id: store.state.core.business_account.account_number,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function get_bills_pay_bill(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        show_remote_error: false,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_pay_bill",
            passager: {
                entity_id: store.state.core.business_account.account_number,
                acc_ref_code: data.ref_code,
                payment_amount: data.amount,
                transaction_number: data.transaction_number
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}


export async function checkPaymentStatus(reference) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_get_payment_status",
            passager: {
                external_reference: reference
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}


export async function initAdvencePayment(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_advance_pay",
            passager: {
                entity_id: store.state.core.business_account.account_number,
                acc_ref_code: data.phone,
                payment_amount: data.amount,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function getMinistatementPdf() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {
            voyager: "akpakpa",
            bus: "bills_download_mini_statement",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
            }
        }
    };
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function download_recu(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "akpakpa",
            bus: "bills_download_receipt",
            passager: {
                external_reference: data.external_reference
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response
}
export async function download_recu_email(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "akpakpa",
            bus: "bills_send_receipt_by_mail",
            passager: {
                external_reference: data.external_reference,
                email: data.email
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response
}

// GET MOMO PIN RESET OTP
export async function getMomoPinResetOtp() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "ndali",
            bus: "momo_gen_otp_for_credential",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response
}

// NEW MOMO CODE WITH OTP PROCESS
export async function sendNewCodeMomo(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "ndali",
            bus: "momo_reset_credential_with_otp",
            passager: {
                otp: data.otp,
                new_secret: data.new_secret
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response
}

// NEW MOMO CODE WITH QUIZ PROCESS
export async function verifyQuestionsResponses(data) {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "ndali",
            bus: "momo_get_fri",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
                questions: data.questions_responses
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response
}

export async function getPinResetMomoQuiz() {
    var config = {
        url: process.env.VUE_APP_SERVICE_ENDPOINT + "voyager",
        type: "POST",
        show_error: true,
        retry: false,
        data: {

            voyager: "ndali",
            bus: "momo_get_auth_questions",
            passager: {
                msisdn: '229' + store.state.core.subscriber.infos.msisdn,
            }
        }
    }
    const response = await utils.utils_async_ajax(config);
    return response

}